<template>
	<div>
		<div class="el-input el-input-group el-input-group--append  el-input-group--prepend Biaodan">
			<div class="tu" @click="Shangchuanqian">
				<span class="el-icon-loading" v-if="shangchengzhong"></span>
				<img :src="value.tu" v-else-if="value.tu" />
				<span class="el-icon-picture-outline" v-else></span>
			</div>
			<input type="text" v-model="value.ming" autocomplete="off" placeholder="请输入内容" class="el-input__inner">
			<div class="el-input-group__append" @click="Lianjie_kuang">链接</div>
			<input type="file" name="file" class="shangchuan" :id="ming" @change="Shangchuanchenggong" />
		</div>
		<el-dialog title="选择链接" :visible.sync="lianjiekuang">		
			<el-input placeholder="请输入链接地址" v-model="Lianjie.url">
				<el-select v-model="Lianjie.fangshi" slot="prepend" placeholder="请选择" style="width: 150px;">
					<el-option label="可后退" value="navigate"></el-option>
					<el-option label="底部导航" value="switchTab"></el-option>
					<el-option label="不可后退" value="redirect"></el-option>					
				</el-select>
				<el-button slot="append" @click="Quren">确定</el-button>
			</el-input>
			<div style=" flex-wrap: wrap;align-content: flex-start;display: flex;padding-top: 20px;">
				<div v-for="l in lie" @click="Lian_jie(l)">
					<el-button size="small" style="margin-right: 10px;margin-bottom: 10px;">{{l.ming}}</el-button>
				</div>
			</div>

		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				Lianjie: {
					fangshi: 'navigate'
				},
				kouling: '',
				lianjiekuang: false,
				shangchengzhong: false,
				lie: [{
						url: '/pages/Limitao/index',
						ming: '首页',
						fangshi: "switchTab"
					},
					{
						url: '/pages/Limitao/fenlei',
						ming: '分类',
						fangshi: "switchTab"
					},
					{
						url: '/pages/Limitao/wode',
						ming: '我的',
						fangshi: "switchTab"
					},
					{
						url: '/pages/Limitao/gouwuche',
						ming: '购物车',
						fangshi: "switchTab"
					},
					{
						url: '/pages/Limitao/xiangqing?id=商品ID',
						ming: '商品',
						fangshi: 'navigate'
					},
					{
						url: '/pages/Limitao/liebiao?id=商品分类ID',
						ming: '商品列表',
						fangshi: 'navigate'
					},
					{
						url: '/pages/Pige/xianshangchaoshi',
						ming: '线上超市',
						fangshi: 'switchTab'
					},
					{
						url: '/pages/Limitao/liebiao',
						ming: '周边商户',
						fangshi: 'switchTab'
					},
					{
						url: '/pages/App/goumaihuiyuan',
						ming: '购买会员',
						fangshi: 'navigate'
					},
					
				],

			}
		},
		props: {
			value: {
				type: [Object, Array],

			},
			ming: {
				type: String
			}
		},
		created() {
			var yonghu = this.$qu('yonghu') || [];
			this.kouling = yonghu.kouling;

		},
		methods: {
			Quren() {
				this.$set(this.value, 'url', this.Lianjie.url)
				this.$set(this.value, 'fangshi', this.Lianjie.fangshi);
				this.lianjiekuang = false;
			},
			Shangchuanchenggong(e) {
				var that = this;
				that.shangchengzhong = true;
				const data = new FormData();
				data.append('file', e.target.files[0]);
				this.$axios.post(this.$url + "?k=wenjian&leixing=tu", data, {
					headers: {
						'Content-Type': 'multipart/form-data',
						'kouling': that.kouling
					},
				}).then(res => {
					if (res.data.shi) {
						that.$set(that.value, 'tu', res.data.shu.url)
					} else {
						that.$xiaoxi(res.data.shu);
					}
					that.shangchengzhong = false;
				}).catch(err => {
					console.log(err);
				});

			},
			Shangchuanqian() {
				document.getElementById(this.ming).click();
			},
			Lian_jie(e) {
				this.Lianjie=e;			
			},
			Lianjie_kuang(){
				this.lianjiekuang=true;			
				this.Lianjie=JSON.parse(JSON.stringify(this.value));
			}
		}
	}
</script>

<style>


</style>
